import { http } from 'connex-cds';

export default {
  listDriverTickets: ({ entityRef, queryParams }) => {
    return http.get({
      apiName: 'mt',
      path: `/${entityRef}/list-driver-tickets`,
      queryParams,
    });
  },
  createTicketForLoad: ({ entityRef, orderRef, loadNumber, payload }) =>
    http.post({
      apiName: 'mt',
      path: `/${entityRef}/orders/${orderRef}/schedule/load/${loadNumber}/ticket`,
      data: payload,
      queryParams: { allowAllAggregateOrders: true },
    }),
};
